var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-attr-filter-content"},[_c('rp-attr-filter-content-filter'),_c('rp-attr-filter-content-tabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }